/**
 * File: assets/breed-checker-modal.js
 * Bootstrap / init only (NO CSS).
 */
(() => {
  const NS = '[BreedModal]';
  const log = (...args) => console.log(NS, ...args);

  const FORCE_PARAM = 'breed_modal';
  const SHOWN_KEY = 'breed_modal_shown_v2';
  const SELECTED_BREED_KEY = 'selected_breed_v2';

  const heroImg = window.PURRZ_MODAL_IMG_URL || '';
  const FLOAT_ICON_URL = window.PURRZ_FACE_ICON_URL || '/cdn/shop/t/0/assets/face.svg';

  const BREEDS_ASSET_URL = window.PURRZ_BREEDS_URL || '/cdn/shop/t/0/assets/breeds-by-size.json';
  const BREEDS_ASSET_URL_FALLBACK = '/cdn/shop/t/0/assets/breeds-by-size.json';

  const BED_SIZE_URLS = {
    small:
      '/collections/cat-beds-caves?filter.v.t.custom.accessory_size=gid%3A%2F%2Fshopify%2FTaxonomyValue%2F2913',
    medium:
      '/collections/cat-beds-caves?filter.v.t.custom.accessory_size=gid%3A%2F%2Fshopify%2FTaxonomyValue%2F2914',
    large:
      '/collections/cat-beds-caves?filter.v.t.custom.accessory_size=gid%3A%2F%2Fshopify%2FTaxonomyValue%2F2915',
  };

  const TREE_SIZE_URLS = {
    small:
      '/collections/cat-trees-towers?filter.v.t.custom.accessory_size=gid%3A%2F%2Fshopify%2FTaxonomyValue%2F2913',
    medium:
      '/collections/cat-trees-towers?filter.v.t.custom.accessory_size=gid%3A%2F%2Fshopify%2FTaxonomyValue%2F2914',
    large:
      '/collections/cat-trees-towers?filter.v.t.custom.accessory_size=gid%3A%2F%2Fshopify%2FTaxonomyValue%2F2915',
  };

  const SCRATCHER_SIZE_URLS = {
    small:
      '/collections/cat-scratchers?filter.v.t.custom.accessory_size=gid%3A%2F%2Fshopify%2FTaxonomyValue%2F2913',
    medium:
      '/collections/cat-scratchers?filter.v.t.custom.accessory_size=gid%3A%2F%2Fshopify%2FTaxonomyValue%2F2914',
    large:
      '/collections/cat-scratchers?filter.v.t.custom.accessory_size=gid%3A%2F%2Fshopify%2FTaxonomyValue%2F2915',
  };

  const SIZE_OPTION_VALUE_MAP = {
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
  };

  const FALLBACK_BREEDS = [
    'American Curl',
    'Balinese',
    'Bambino',
    'Cornish Rex',
    'Devon Rex',
    'Dwelf',
    'German Rex',
    'Japanese Bobtail',
    'Khao Manee',
    'Kinkalow',
    'Lambkin',
    'Minskin',
    'Munchkin',
    'Napoleon',
    'Peterbald',
    'Russian Blue',
    'Scottish Fold',
    'Scottish Straight',
    'Siamese',
    'Singapura',
    'Skookum',
    'Snowshoe',
    'Sphynx',
    'Thai',
    'Tonkinese',
    'Toybob',
    'Ukrainian Levkoy',
  ];

  const COLLECTION_GRID_SECTION_ID =
    window.PURRZ_COLLECTION_GRID_SECTION_ID || 'main-collection-product-grid';

  const FLOAT_BTN_ID = 'purrz-breed-float-btn';

  function hasForceFlag() {
    try {
      return new URLSearchParams(location.search).has(FORCE_PARAM);
    } catch {
      return false;
    }
  }

  async function init() {
    if (!window.PURRZ_BREED_MODAL_CORE?.createCore) {
      console.error(NS, 'Missing core: PURRZ_BREED_MODAL_CORE.createCore');
      return;
    }

    if (!window.PURRZ_BREED_MODAL_UI?.createUI) {
      console.error(NS, 'Missing ui: PURRZ_BREED_MODAL_UI.createUI');
      return;
    }

    window.PURRZ_BREED_MODAL_STYLES?.inject?.();

    const core = window.PURRZ_BREED_MODAL_CORE.createCore({
      shownKey: SHOWN_KEY,
      selectedBreedKey: SELECTED_BREED_KEY,

      breedsUrl: BREEDS_ASSET_URL,
      breedsUrlFallback: BREEDS_ASSET_URL_FALLBACK,

      fallbackBreeds: FALLBACK_BREEDS,

      bedSizeUrls: BED_SIZE_URLS,
      treeSizeUrls: TREE_SIZE_URLS,
      scratcherSizeUrls: SCRATCHER_SIZE_URLS,

      sizeOptionValueMap: SIZE_OPTION_VALUE_MAP,
      collectionGridSectionId: COLLECTION_GRID_SECTION_ID,
      variantOptionNameHints: ['size'],
      maxVariantFetch: 30,
    });

    const ui = window.PURRZ_BREED_MODAL_UI.createUI(
      {
        heroImg,
        floatBtnId: FLOAT_BTN_ID,
        floatIconUrl: FLOAT_ICON_URL,
      },
      core
    );

    // PERF-13 (PURRZ performance plan 2026-10-28): the breed list is fetched on the first open, not at
    // DOMContentLoaded on every page. ensureBreeds() loads and binds it once; the open waits for it, because
    // ui.open re-runs a saved breed through what ui.bind sets up. Tested by tests/theme/breed-checker-lazy.test.mjs.
    let breedsReady = null;
    const ensureBreeds = () => {
      if (!breedsReady) {
        breedsReady = core.loadBreeds().then((loaded) => {
          ui.bind(core.uniqueSorted(loaded.list));
        });
      }
      return breedsReady;
    };

    const open = async () => {
      await ensureBreeds();
      ui.open();
    };

    window.PURRZ_BREED_MODAL = window.PURRZ_BREED_MODAL || {};
    window.PURRZ_BREED_MODAL.open = open;
    window.PURRZ_BREED_MODAL.close = ui.close;

    if (ui.floatBtn) {
      ui.floatBtn.addEventListener('click', open);
    }

    // if (hasForceFlag()) {
    //   ui.open();
    //   log('Forced open via ?breed_modal');
    // }
  }

  document.addEventListener('DOMContentLoaded', init);
})();
